const TIMEOUT_MESSAGE = 'Billing request timed out';

/** Rejects once `ms` pass, so a slow billing call never holds a screen. */
export async function withTimeout<T>(request: Promise<T>, ms: number): Promise<T> {
  let timeout: number | undefined;
  try {
    return await Promise.race([
      request,
      new Promise<never>((_, reject) => {
        timeout = window.setTimeout(() => reject(new Error(TIMEOUT_MESSAGE)), ms);
      })
    ]);
  } finally {
    if (timeout !== undefined) window.clearTimeout(timeout);
  }
}
